<div class="bloque-de-bienvenida-section">
    <div class="container pt-5">
        <div class="color-opaco pb-5">
            <h2>Registro usuario paciente cannabis medicinal</h2>
            <small >El presente documento reviste carácter de DECLARACION JURADA.</small>
            <br>
            <small>La autoridad de aplicación se reserva el derecho a verificar los datos declarados.</small>
        </div>

        <i>{{errorMessage}}</i>

        <div class="container container-personalize">
            
            <div class="color-opaco">
                <div class="row">
                    <div class="col-sm-6 d-flex justify-content-start">
                        <h3>Datos del paciente</h3>
                    </div>
                </div>
            </div>

            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="row mt-2">
                    <div class="col-sm">
                        <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                            Nombre y Apellido
                        </label>
                        <input 
                        [ngClass]="{'is-invalid': form.get('nombreApellido')?.invalid && (form.get('nombreApellido')?.touched || form.get('nombreApellido')?.dirty)}"
                        formControlName="nombreApellido" class="form-control" type="text" placeholder="nombres y apellidos" aria-label="example">

                        <div *ngIf="form.get('nombreApellido')?.invalid && (form.get('nombreApellido')?.touched || form.get('nombreApellido')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                            <span *ngIf="form.get('nombreApellido')?.errors?.['required']">{{campoObligatorio}}</span>
                        </div>

                    </div>
                    <div class="col-sm">
                        <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                            Tipo y número de documento
                        </label>
                        <div class="row">
                            <div class="col-4">
                                <select formControlName="tipoDocumento" class="form-select" aria-label="Default select example">
                                    <option selected>dni</option>
                                    <option value="1">dnie</option>
                                    <option value="2">pasaporte</option>
                                </select>
                            </div>
                            <div class="col-8">
                                <input 
                                [ngClass]="{'is-invalid': form.get('nroDocumento')?.invalid && (form.get('nroDocumento')?.touched || form.get('nroDocumento')?.dirty)}"
                                formControlName="nroDocumento" class="form-control" type="text" 
                                placeholder="12345678" aria-label="example">
                                <div *ngIf="form.get('nroDocumento')?.invalid && (form.get('nroDocumento')?.touched || form.get('nroDocumento')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                    <span *ngIf="form.get('nroDocumento')?.errors?.['required']">{{campoObligatorio}}</span>
                                    <span *ngIf="form.get('nroDocumento')?.errors?.['pattern']">Solo se permiten números.</span>
                                    <span *ngIf="form.get('nroDocumento')?.errors?.['minlength']">Debe tener al menos 4 dígitos.</span>
                                    <span *ngIf="form.get('nroDocumento')?.errors?.['maxlength']">Debe tener máximo 11 dígitos.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm">
                        <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                            Fecha de nacimiento
                        </label>
                        <input 
                            [ngClass]="{'is-invalid': form.get('fechaNacimiento')?.invalid && (form.get('fechaNacimiento')?.touched || form.get('fechaNacimiento')?.dirty)}"
                            formControlName="fechaNacimiento"
                            class="form-control"
                            (change)="onDateChange($event)"
                            type="date"
                            value="today"
                            min="minAge"
                            max="maxAge" />
                            
                            <div *ngIf="form.get('fechaNacimiento')?.invalid && (form.get('fechaNacimiento')?.touched || form.get('fechaNacimiento')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                <span *ngIf="form.get('fechaNacimiento')?.errors?.['required']">{{campoObligatorio}}</span>
                            </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm">
                        <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                            Domicilio
                        </label>
                        <input 
                        [ngClass]="{'is-invalid': form.get('domicilio')?.invalid && (form.get('domicilio')?.touched || form.get('domicilio')?.dirty)}"
                        formControlName="domicilio" class="form-control" type="text" placeholder="domicilio" aria-label="example">

                        <div *ngIf="form.get('domicilio')?.invalid && (form.get('domicilio')?.touched || form.get('domicilio')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                            <span *ngIf="form.get('domicilio')?.errors?.['required']">{{campoObligatorio}}</span>
                        </div>
                    </div>
                    <div class="col-sm">
                        <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                            Localidad
                        </label>
                        <input 
                        [ngClass]="{'is-invalid': form.get('localidad')?.invalid && (form.get('localidad')?.touched || form.get('localidad')?.dirty)}"
                        formControlName="localidad" class="form-control" type="text" placeholder="Localidad" aria-label="example">
                        <div *ngIf="form.get('localidad')?.invalid && (form.get('localidad')?.touched || form.get('localidad')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                            <span *ngIf="form.get('localidad')?.errors?.['required']">{{campoObligatorio}}</span>
                        </div>
                    </div>
                    <div class="col-sm">
                        <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                            Provincia
                        </label>
                        <div class="row">
                            <div class="col">
                                <select 
                                [ngClass]="{'is-invalid': form.get('provincia')?.invalid && (form.get('provincia')?.touched || form.get('provincia')?.dirty)}"    
                                formControlName="provincia" class="form-select" aria-label="Default select example">
                                    <option value="1">BUENOS AIRES</option>
                                    <option value="2">CATAMARCA</option>
                                    <option value="3">CORDOBA</option>
                                    <option value="4">CORRIENTES</option>
                                    <option value="5">CHACO</option>
                                    <option value="6">CHUBUT</option>
                                    <option value="7">ENTRE RIOS</option>
                                    <option value="8">FORMOSA</option>
                                    <option value="9">JUJUY</option>
                                    <option value="10">LA PAMPA</option>
                                    <option value="11">LA RIOJA</option>
                                    <option value="12">MENDOZA</option>
                                    <option value="13">MISIONES</option>
                                    <option value="14">NEUQUEN</option>
                                    <option value="15">RIO NEGRO</option>
                                    <option value="16">SALTA</option>
                                    <option value="17">SAN LUIS</option>
                                    <option value="19">SANTA CRUZ</option>
                                    <option value="20">SANTA FE</option>
                                    <option value="21">SANTIAGO DEL ESTERO</option>
                                    <option value="22">TIERRA DEL FUEGO</option>
                                    <option value="23">TUCUMAN</option>
                                    <option value="50">CIUDAD AUTONOMA DE Bs As</option>
                                    <option disabled="true" selected="true" value="">Seleccionar una Provincia</option>
                                </select>
                                <div *ngIf="form.get('provincia')?.invalid && (form.get('provincia')?.touched || form.get('provincia')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                    <span *ngIf="form.get('provincia')?.errors?.['required']">{{campoObligatorio}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm">
                        <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                            C.P.
                        </label>
                        <input 
                        [ngClass]="{'is-invalid': form.get('codigoPostal')?.invalid && (form.get('codigoPostal')?.touched || form.get('codigoPostal')?.dirty)}"
                        formControlName="codigoPostal" class="form-control" type="text" placeholder="Código postal" aria-label="example">

                        <div *ngIf="form.get('codigoPostal')?.invalid && (form.get('codigoPostal')?.touched || form.get('codigoPostal')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                            <span *ngIf="form.get('codigoPostal')?.errors?.['required']">{{campoObligatorio}}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm">
                        <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                            Teléfono celular
                        </label>
                        <input 
                        [ngClass]="{'is-invalid': form.get('telefono')?.invalid && (form.get('telefono')?.touched || form.get('telefono')?.dirty)}"
                        formControlName="telefono" class="form-control" type="text" placeholder="+54 9 xx xxxx xxxx" aria-label="example">

                        <div *ngIf="form.get('telefono')?.invalid && (form.get('telefono')?.touched || form.get('telefono')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                            <span *ngIf="form.get('telefono')?.errors?.['required']">{{campoObligatorio}}</span>
                        </div>
                    </div>
                    <div class="col-sm">
                        <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                            Correo electrónico
                        </label>
                        <input 
                        [ngClass]="{'is-invalid': form.get('correo')?.invalid && (form.get('correo')?.touched || form.get('correo')?.dirty)}"
                        formControlName="correo" type="email" class="form-control" placeholder="name@example.com">

                        <div *ngIf="form.get('correo')?.invalid && (form.get('correo')?.touched || form.get('correo')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                            <span *ngIf="form.get('correo')?.errors?.['required']">{{campoObligatorio}}</span>
                        </div>
                    </div>

                    <div class="col-sm">
                        <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                            Obra social
                        </label>

                        <div class="row">
                            <div class="col d-flex justify-content-start">
                                <input formControlName="tieneObraSocial" [value]="true" type="radio" class="btn-check" name="tieneObraSocial" id="success-outlined-obra" autocomplete="off">
                                <label 
                                [ngClass]="{'max-h-65-porcent': form.get('obraSocial')?.invalid && (form.get('obraSocial')?.touched || form.get('obraSocial')?.dirty) }"
                                class="btn btn-outline-success h-100 mx-1" for="success-outlined-obra">Si</label>

                                <input formControlName="tieneObraSocial" [value]="false" type="radio" class="btn-check" name="tieneObraSocial" id="danger-outlined-obra" autocomplete="off">
                                <label 
                                [ngClass]="{'max-h-65-porcent': form.get('obraSocial')?.invalid && (form.get('obraSocial')?.touched || form.get('obraSocial')?.dirty) }"
                                class="btn btn-outline-secondary h-100 mx-1" for="danger-outlined-obra">No</label>
                            

                                <div *ngIf="form.get('tieneObraSocial')?.value" class="form-group w-100">
                                    <input 
                                    [ngClass]="{'is-invalid': form.get('obraSocial')?.invalid && (form.get('obraSocial')?.touched || form.get('obraSocial')?.dirty)}"
                                    *ngIf="form.get('tieneObraSocial')?.value" formControlName="obraSocial" type="text" class="form-control" id="exampleFormControlInput1" placeholder="obra social">
                                    
                                    <div *ngIf="form.get('obraSocial')?.invalid && (form.get('obraSocial')?.touched || form.get('obraSocial')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                        <span *ngIf="form.get('obraSocial')?.errors?.['required']">{{campoObligatorio}}</span>
                                    </div>
                                </div>

                                
                            </div>
                        </div>            
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm">
                        <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                            REPROCAN
                        </label>
                        <div class="row">
                            <div class="col-sm-4 d-flex justify-content-start">

                              <input formControlName="tieneRepro" name="tieneRepro" [value]="true" type="radio" class="btn-check" id="success-outlined-repro" autocomplete="off" checked>
                              <label 
                              [ngClass]="{'max-h-65-porcent': form.get('codigoVinculacion')?.invalid && (form.get('codigoVinculacion')?.touched || form.get('codigoVinculacion')?.dirty) }"
                              class="btn btn-outline-success mx-1" for="success-outlined-repro">Sí</label>
                          
                              <input formControlName="tieneRepro" name="tieneRepro" [value]="false" type="radio" class="btn-check" id="danger-outlined-repro" autocomplete="off">
                              <label 
                              [ngClass]="{'max-h-65-porcent': form.get('codigoVinculacion')?.invalid && (form.get('codigoVinculacion')?.touched || form.get('codigoVinculacion')?.dirty) }"
                              class="btn btn-outline-secondary mx-1" for="danger-outlined-repro">No</label>
                          
                              <div *ngIf="form.get('tieneRepro')?.value" class="form-group w-100">
                                <input
                                  [ngClass]="{'is-invalid': form.get('codigoVinculacion')?.invalid && (form.get('codigoVinculacion')?.touched || form.get('codigoVinculacion')?.dirty)}"
                                  formControlName="codigoVinculacion"
                                  type="text"
                                  class="form-control"
                                  id="codigoVinculacion"
                                  placeholder="Código de vinculación">
                          
                                <div *ngIf="form.get('codigoVinculacion')?.invalid && (form.get('codigoVinculacion')?.touched || form.get('codigoVinculacion')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                  {{ campoObligatorio }}
                                </div>
                              </div>
                            </div>
                          </div>
                          
                    </div>
                </div>


                <div *ngIf="menorEdad" class="mt-4">
                    <div class="color-opaco">
                        <div class="row">
                            <div class="col-sm-6 d-flex justify-content-start">
                                <h3>Datos del padre/madre/tutor o encargado</h3>
                            </div>
                            <div class="col-sm-6 d-flex justify-content-start">
                                <small class="mx-2 mt-2"> (Completar en caso de paciente menor de edad)</small>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row mt-2">
                        <div class="col-sm">
                            <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                                Nombres y Apellidos
                            </label>
                            <input
                            [ngClass]="{'is-invalid': form.get('nombreApellidoTutor')?.invalid && (form.get('nombreApellidoTutor')?.touched || form.get('nombreApellidoTutor')?.dirty)}"
                            formControlName="nombreApellidoTutor" 
                            class="form-control" type="text" 
                            placeholder="nombres y apellidos" aria-label="example">

                            <div *ngIf="form.get('nombreApellidoTutor')?.invalid && (form.get('nombreApellidoTutor')?.touched || form.get('nombreApellidoTutor')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                <span *ngIf="form.get('nombreApellidoTutor')?.errors?.['required']">{{campoObligatorio}}</span>
                            </div>

                        </div>
                        <div class="col-sm">
                            <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                                Tipo y Nro Documento
                            </label>
                            <div class="row">
                                <div class="col-4">
                                    <select formControlName="tipoDocumentoTutor" class="form-select" aria-label="Default select example">
                                        <option selected>dni</option>
                                        <option value="1">dnie</option>
                                        <option value="2">pasaporte</option>
                                    </select>
                                </div>
                                <div class="col-8">
                                    <input 
                                    [ngClass]="{'is-invalid': form.get('nroDocumentoTutor')?.invalid && (form.get('nroDocumentoTutor')?.touched || form.get('nroDocumentoTutor')?.dirty)}"
                                    formControlName="nroDocumentoTutor" class="form-control" type="text" placeholder="12345678" aria-label="example">

                                    <div *ngIf="form.get('nroDocumentoTutor')?.invalid && (form.get('nroDocumentoTutor')?.touched || form.get('nroDocumentoTutor')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                        <span *ngIf="form.get('nroDocumentoTutor')?.errors?.['required']">{{campoObligatorio}}</span>
                                        <span *ngIf="form.get('nroDocumentoTutor')?.errors?.['pattern']">Solo se permiten números.</span>
                                        <span *ngIf="form.get('nroDocumentoTutor')?.errors?.['minlength']">Debe tener al menos 4 dígitos.</span>
                                        <span *ngIf="form.get('nroDocumentoTutor')?.errors?.['maxlength']">Debe tener máximo 11 dígitos.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm">
                            <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                                Fecha de nac.
                            </label>
                            <input 
                                [ngClass]="{'is-invalid': form.get('fechaNacimientoTutor')?.invalid && (form.get('fechaNacimientoTutor')?.touched || form.get('fechaNacimientoTutor')?.dirty)}"
                                formControlName="fechaNacimientoTutor"
                                class="form-control"
                                (change)="onDateChangeTutor($event)"
                                type="date"
                                value="today"
                                min="minAge"
                                max="maxAge" />

                            <div *ngIf="form.get('fechaNacimientoTutor')?.hasError('notAdult') && form.get('fechaNacimientoTutor')?.touched" class="text-danger d-flex justify-content-start">
                                El tutor debe ser mayor de edad.
                            </div>
                                  
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm">
                            <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                                Domicilio
                            </label>
                            <input 
                            [ngClass]="{'is-invalid': form.get('domicilioTutor')?.invalid && (form.get('domicilioTutor')?.touched || form.get('domicilioTutor')?.dirty)}"
                            formControlName="domicilioTutor" class="form-control" type="text" placeholder="domicilio" aria-label="example">

                            <div *ngIf="form.get('domicilioTutor')?.invalid && (form.get('domicilioTutor')?.touched || form.get('domicilioTutor')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                <span *ngIf="form.get('domicilioTutor')?.errors?.['required']">{{campoObligatorio}}</span>
                            </div>
                        </div>
                        <div class="col-sm">
                            <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                                Localidad
                            </label>
                            <input 
                            [ngClass]="{'is-invalid': form.get('localidadTutor')?.invalid && (form.get('localidadTutor')?.touched || form.get('localidadTutor')?.dirty)}"
                            formControlName="localidadTutor" class="form-control" type="text" placeholder="Localidad" aria-label="example">

                            <div *ngIf="form.get('localidadTutor')?.invalid && (form.get('localidadTutor')?.touched || form.get('localidadTutor')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                <span *ngIf="form.get('localidadTutor')?.errors?.['required']">{{campoObligatorio}}</span>
                            </div>
                        </div>
                        <div class="col-sm">
                            <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                                Provincia
                            </label>
                            <div class="row">
                                <div class="col">
                                    <select 
                                    [ngClass]="{'is-invalid': form.get('provinciaTutor')?.invalid && (form.get('provinciaTutor')?.touched || form.get('provinciaTutor')?.dirty)}"
                                    formControlName="provinciaTutor" class="form-select" aria-label="Default select example">
                                        <option value="1">BUENOS AIRES</option>
                                        <option value="2">CATAMARCA</option>
                                        <option value="3">CORDOBA</option>
                                        <option value="4">CORRIENTES</option>
                                        <option value="5">CHACO</option>
                                        <option value="6">CHUBUT</option>
                                        <option value="7">ENTRE RIOS</option>
                                        <option value="8">FORMOSA</option>
                                        <option value="9">JUJUY</option>
                                        <option value="10">LA PAMPA</option>
                                        <option value="11">LA RIOJA</option>
                                        <option value="12">MENDOZA</option>
                                        <option value="13">MISIONES</option>
                                        <option value="14">NEUQUEN</option>
                                        <option value="15">RIO NEGRO</option>
                                        <option value="16">SALTA</option>
                                        <option value="17">SAN LUIS</option>
                                        <option value="19">SANTA CRUZ</option>
                                        <option value="20">SANTA FE</option>
                                        <option value="21">SANTIAGO DEL ESTERO</option>
                                        <option value="22">TIERRA DEL FUEGO</option>
                                        <option value="23">TUCUMAN</option>
                                        <option value="50">CIUDAD AUTONOMA DE Bs As</option>
                                        <option disabled="true" selected="true" value="">Seleccionar una Provincia</option>
                                    </select>
                                    <div *ngIf="form.get('provinciaTutor')?.invalid && (form.get('provinciaTutor')?.touched || form.get('provinciaTutor')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                        <span *ngIf="form.get('provinciaTutor')?.errors?.['required']">{{campoObligatorio}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm">
                            <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                                C.P.
                            </label>
                            <input 
                            [ngClass]="{'is-invalid': form.get('codigoPostalTutor')?.invalid && (form.get('codigoPostalTutor')?.touched || form.get('codigoPostalTutor')?.dirty)}"
                            formControlName="codigoPostalTutor" class="form-control" type="text" placeholder="Código postal" aria-label="example">

                            <div *ngIf="form.get('codigoPostalTutor')?.invalid && (form.get('codigoPostalTutor')?.touched || form.get('codigoPostalTutor')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                <span *ngIf="form.get('codigoPostalTutor')?.errors?.['required']">{{campoObligatorio}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm">
                            <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                                Vinculo con paciente
                            </label>
                            <input 
                            [ngClass]="{'is-invalid': form.get('vinculoTutorPaciente')?.invalid && (form.get('vinculoTutorPaciente')?.touched || form.get('vinculoTutorPaciente')?.dirty)}"
                            formControlName="vinculoTutorPaciente" class="form-control" type="text" placeholder="Padre/Madre o tutor" aria-label="example">
                            <div *ngIf="form.get('vinculoTutorPaciente')?.invalid && (form.get('vinculoTutorPaciente')?.touched || form.get('vinculoTutorPaciente')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                <span *ngIf="form.get('vinculoTutorPaciente')?.errors?.['required']">{{campoObligatorio}}</span>
                            </div>
                        </div>
                        <div class="col-sm">
                            <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                                Teléfono
                            </label>
                            <input 
                            [ngClass]="{'is-invalid': form.get('telefonoTutor')?.invalid && (form.get('telefonoTutor')?.touched || form.get('telefonoTutor')?.dirty)}"
                            formControlName="telefonoTutor" class="form-control" type="text" placeholder="Teléfono" aria-label="example">

                            <div *ngIf="form.get('telefonoTutor')?.invalid && (form.get('telefonoTutor')?.touched || form.get('telefonoTutor')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                <span *ngIf="form.get('telefonoTutor')?.errors?.['required']">{{campoObligatorio}}</span>
                            </div>
                        </div>
                        <div class="col-sm">
                            <label for="exampleInputEmail1" class="form-label color-opaco d-flex justify-content-start pt-2">
                                Correo electrónico
                            </label>
                            <input 
                            [ngClass]="{'is-invalid': form.get('correoTutor')?.invalid && (form.get('correoTutor')?.touched || form.get('correoTutor')?.dirty)}"
                            formControlName="correoTutor" class="form-control" type="text" placeholder="name@example.com" aria-label="example">

                            <div *ngIf="form.get('correoTutor')?.invalid && (form.get('correoTutor')?.touched || form.get('correoTutor')?.dirty)" class="invalid-feedback d-flex justify-content-start">
                                <span *ngIf="form.get('correoTutor')?.errors?.['required']">{{campoObligatorio}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-end">
                    <button type="submit" class="btn btn-success mt-2">Continuar</button>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="modal fade background-modal" id="modalReviseCambios" tabindex="-1" aria-labelledby="modalReviseCambiosLabel" aria-hidden="true">
    <div class="modal-dialog ">
        <div class="modal-content d-flex justify-content-center">
            <div class="modal-header modal-revise-cambios">
                <h5 class="modal-title col-12 text-center">Porfavor, revise el formulario</h5>
            </div>
            <div class="modal-body d-flex justify-content-center">
                <p>complete todos los campos obligatorios.</p>
            </div>
            <div class="modal-footer d-flex justify-content-center">
                <button type="button" class="btn btn-success" (click)="closeModals()">Entendido</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade background-modal" id="modalFormularioExitoso" tabindex="-1" aria-labelledby="modalReviseCambiosLabel" aria-hidden="true">
    <div class="modal-dialog ">
        <div class="modal-content d-flex justify-content-center">
            <div class="modal-header">
                <h5 class="modal-title col-12 text-center">Información cargada con éxito</h5>
            </div>
            <div class="modal-body d-flex justify-content-center">
                <p>Se envió un email a su casilla de corre {{form.get('correo')?.value}}</p>
            </div>
            <div class="modal-footer d-flex justify-content-center">
                <button type="button" class="btn btn-success" (click)="closeModals(); irConfirmarUsuario()">Entendido</button>
            </div>
        </div>
    </div>
</div>


<div class="modal fade background-modal" id="errorServicio" tabindex="-1" aria-labelledby="modalErrorServicio" aria-hidden="true">
    <div class="modal-dialog ">
        <div class="modal-content d-flex justify-content-center">
            <div class="modal-header">
                <h5 class="modal-title col-12 text-center">ERROR AL INSCRIBIRSE</h5>
            </div>
            <div class="modal-body d-flex justify-content-center">
                <p class="text-danger">
                    Ocurrió un problema al inscribirse, por favor comuníquese con su proveedor.
                </p>
            </div>
            <div class="modal-footer d-flex justify-content-center">
                <button type="button" class="btn btn-success" (click)="closeModals();">De acuerdo</button>
            </div>
        </div>
    </div>
</div>
  